export default __webpack_public_path__ + "static/media/Red and Black Woman Edgy Monochrome Halloween Party Poster.4354fcd7.jpg";